import { jsxs as _jsxs } from "react/jsx-runtime";
import "./Copyright.css";
const Copyright = () => {
    const currentYear = new Date().getFullYear();
    return (_jsxs("small", Object.assign({ className: "copyright", "data-testid": "copyright" }, { children: ["Copyright \u00A9 2010-", currentYear, " Veeva Systems. All rights reserved."] })));
};
export default Copyright;
